export const formatTime = (dateTimeString) => 
    new Date(dateTimeString).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
    });
  
  export const getActualStartDate = (section) => {
    if (!section.meetings.length) return new Date(section.startDate);
    const sorted = [...section.meetings].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
    return new Date(sorted[0].startTime);
  };
  
  export const getActualEndDate = (section) => {
    if (!section.meetings.length) return new Date(section.endDate);
    const sorted = [...section.meetings].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
    return new Date(sorted[sorted.length - 1].endTime);
  };